import { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  useDisclosure,
} from "@heroui/react";
import { api } from "@/api";

interface CianSmsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSmsSubmitted: () => void;
}

export function CianSmsModal({
  isOpen,
  onClose,
  onSmsSubmitted,
}: CianSmsModalProps) {
  const [smsCode, setSmsCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const {
    isOpen: isSendSmsOpen,
    onOpen: onSendSmsOpen,
    onClose: onSendSmsClose,
  } = useDisclosure();

  const handleSendSms = async () => {
    try {
      setIsLoading(true);
      setError(null);
      await api.cian.sendSms();
      onSendSmsClose();
    } catch (error) {
      setError("Ошибка при отправке SMS");
      console.error("Ошибка при отправке SMS:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitSms = async () => {
    if (!smsCode.trim()) {
      setError("Введите код из SMS");
      return;
    }

    try {
      setIsLoading(true);
      setError(null);
      await api.cian.submitSms(smsCode);
      onSmsSubmitted();
    } catch (error) {
      setError("Неверный код SMS");
      console.error("Ошибка при подтверждении SMS:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setSmsCode("");
    setError(null);
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClose} size="md">
        <ModalContent>
          <ModalHeader>Подтверждение SMS</ModalHeader>
          <ModalBody>
            <div className="space-y-4">
              <p className="text-sm text-gray-600">
                Для работы с Cian необходимо подтвердить номер телефона. Введите
                код, который был отправлен в SMS.
              </p>

              <div className="space-y-2">
                <label className="text-sm font-medium">Код из SMS</label>
                <Input
                  type="text"
                  placeholder="Введите код"
                  value={smsCode}
                  onChange={(e) => setSmsCode(e.target.value)}
                  isInvalid={!!error}
                  errorMessage={error}
                  maxLength={6}
                />
              </div>

              <div className="text-center">
                <Button
                  variant="light"
                  color="primary"
                  onPress={onSendSmsOpen}
                  isLoading={isLoading}
                >
                  Отправить SMS повторно
                </Button>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button variant="light" onPress={handleClose}>
              Отмена
            </Button>
            <Button
              color="primary"
              onPress={handleSubmitSms}
              isLoading={isLoading}
              isDisabled={!smsCode.trim()}
            >
              Подтвердить
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Модаль для отправки SMS */}
      <Modal isOpen={isSendSmsOpen} onClose={onSendSmsClose} size="sm">
        <ModalContent>
          <ModalHeader>Отправка SMS</ModalHeader>
          <ModalBody>
            <p>Отправить SMS с кодом подтверждения?</p>
          </ModalBody>
          <ModalFooter>
            <Button variant="light" onPress={onSendSmsClose}>
              Отмена
            </Button>
            <Button
              color="primary"
              onPress={handleSendSms}
              isLoading={isLoading}
            >
              Отправить
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
